<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="vendor-list-container">
  <!-- Toolbar -->
  <div class="vendor-list-toolbar">
    <div class="vendor-list-filters">
      <p-dropdown
        [options]="[{label: 'All Regions', value: null}, ...regionOptions]"
        [(ngModel)]="regionFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Region"
        [showClear]="true"
        styleClass="vendor-filter-dd">
      </p-dropdown>
      <p-dropdown
        [options]="[{label: 'All Types', value: null}, ...vendorTypeOptions]"
        [(ngModel)]="vendorTypeFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Vendor Type"
        [showClear]="true"
        styleClass="vendor-filter-dd">
      </p-dropdown>
      <p-dropdown
        [options]="activeOptions"
        [(ngModel)]="activeFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Status"
        styleClass="vendor-filter-dd">
      </p-dropdown>
    </div>
    <button pButton pRipple
      class="p-button btn-blue"
      label="New Vendor +"
      (click)="onNewVendor()">
    </button>
  </div>

  <p-table
    #pt
    [value]="vendors"
    [lazy]="true"
    (onLazyLoad)="loadLazy($event)"
    dataKey="vendorId"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
    [loading]="loading"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[25, 50, 100]"
    [totalRecords]="recordTotal"
    showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} vendors. Page {currentPage} of {totalPages}"
    sortMode="multiple"
    [multiSortMeta]="multiSortMeta"
    styleClass="p-datatable-striped"
    [resizableColumns]="true"
    [autoLayout]="true"
    [globalFilterFields]="['name', 'legalName', 'primaryContactEmail']">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
        <th pSortableColumn="region">Region <p-sortIcon field="region"></p-sortIcon></th>
        <th pSortableColumn="vendorType">Vendor Type <p-sortIcon field="vendorType"></p-sortIcon></th>
        <th pSortableColumn="paymentMethod">Payment Method <p-sortIcon field="paymentMethod"></p-sortIcon></th>
        <th pSortableColumn="paymentTermsDays">Net N Days <p-sortIcon field="paymentTermsDays"></p-sortIcon></th>
        <th pSortableColumn="isActive">Active <p-sortIcon field="isActive"></p-sortIcon></th>
        <th pSortableColumn="createDate">Created Date <p-sortIcon field="createDate"></p-sortIcon></th>
        <th>Actions</th>
      </tr>
      <tr>
        <th><input pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'contains')" style="width:100%"></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-vendor>
      <tr [pSelectableRow]="vendor" style="cursor:pointer">
        <td>
          <strong>{{vendor.name}}</strong>
          <div *ngIf="vendor.legalName" style="font-size:0.8em;color:#888">{{vendor.legalName}}</div>
        </td>
        <td>{{getRegionLabel(vendor.region)}}</td>
        <td>{{getVendorTypeLabel(vendor.vendorType)}}</td>
        <td>{{getPaymentLabel(vendor.paymentMethod)}}</td>
        <td>Net {{vendor.paymentTermsDays}}</td>
        <td>
          <span [class]="vendor.isActive ? 'p-tag p-tag-success' : 'p-tag p-tag-danger'">
            {{vendor.isActive ? 'Active' : 'Inactive'}}
          </span>
        </td>
        <td>{{vendor.createDate | date:'MM/dd/yyyy'}}</td>
        <td>
          <button pButton pRipple
            icon="pi pi-pencil"
            class="p-button-text p-button-sm"
            (click)="$event.stopPropagation(); onEditVendor(vendor)">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align:center; padding:2rem;">No vendors found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
